import React from 'react';
import ReactDOM from 'react-dom/client';
import AdminApp from './admin';
import FrontendApp from './frontend';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './tailwind.css';

const rootElement = document.getElementById('client-root');
const defaultRoutePath = rootElement?.attributes["data-route"];

if (defaultRoutePath) {
    window.defaultRoutePath = defaultRoutePath.value;
}

const root = ReactDOM.createRoot(rootElement);

root.render(
        <Router>
            <Routes>
                <Route path="/education-admin/*" element={<AdminApp />} />
                <Route path="/education/v1/*" element={<FrontendApp />} />
            </Routes>
        </Router>
);

reportWebVitals();